<template>
    <nav class="flex items-center flex-wrap -mx-2 mb-8">
        <label for="news-genre" class="sr-only">Genre</label>
        <select id="news-genre" v-model="genre" title="Genre" class="form-select inline-block w-auto mx-2">
            <option :value="null">Genre</option>
            <option v-for="g in genres" :key="g.value" :value="g.value">{{ g.label }}</option>
        </select>
    </nav>

    <div
        v-infinite-scroll="onLoadMore"
        class="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 grid-flow-row auto-rows-max gap-4 lg:gap-8"
        infinite-scroll-disabled="disableLazyLoad"
        infinite-scroll-distance="10"
        infinite-scroll-immediate-check="false"
    >
        <news-item
            v-for="entry in news"
            :key="entry.id"
            :entry="entry"
        />
    </div>
</template>

<script setup>
    import { computed, ref } from 'vue';
    import { useQuery } from '@vue/apollo-composable';
    import { GET_NEWS_QUERY } from '@/graphql/news';
    import NewsItem from '@/js/components/NewsItem.vue';

    const props = defineProps({
        genres: {
            type: Array,
            required: true,
        },
    });

    const page = ref(0);
    const genre = ref(null);
    const disableLazyLoad = ref(true);

    const entriesPerPage = 12;

    const { result, fetchMore } = useQuery(GET_NEWS_QUERY, () => ({
        limit: entriesPerPage,
        offset: 0,
        genre: genre.value ? [ genre.value ] : undefined,
    }));

    const news = computed(() => result.value?.entries || []);

    const onLoadMore = async() => {
        page.value++;
        const offset = page.value * entriesPerPage;

        await fetchMore({
            variables: {
                limit: entriesPerPage,
                offset,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const entries = [
                    ...previousResult.entries,
                    ...fetchMoreResult.entries,
                ];

                disableLazyLoad.value = fetchMoreResult.entries.length < entriesPerPage;

                return {
                    entries,
                };
            },
        });
    };
</script>
